import { css, cx } from 'emotion';

import SubmittedBG from 'inside-out/images/submitted-bg.svg';

import {
	lightGrey,
	headingLarge,
	headingXLarge,
	mobileMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
	textBlock,
	tabletPortraitMinWidthBreakpoint,
} from 'inside-out/global-styles';

export const innerStyleOrganisation = css({
	width: '130px',
	height: '130px',
	lineHeight: '130px',
	border: `1px solid ${lightGrey}`,
	borderRadius: '6px',
	float: 'right',
	textAlign: 'center',
	'& img': {
		maxWidth: '105px',
	},
});

export const innerStyleIndividual = css({
	marginBottom: '24px',
});

export const metaAudiencesStyle = css({
	marginBottom: '40px',
	'& span:not(:last-child)': {
		marginRight: '8px',
	},
});

export const wrapperStyle = css({
	background: `transparent url(${SubmittedBG}) no-repeat bottom right`,
});

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	position: 'relative',
});

export const cardsSectionStyle = css({
	marginTop: '60px',
	width: '266px',
});

export const textStyle = cx(
	textBlock,
	css({
		maxWidth: '580px',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '14px',
		},
	})
);

export const titleStyle = cx(
	headingXLarge,
	css({
		margin: '0 0 20px 0',
	})
);

export const contactTitleStyle = cx(
	headingLarge,
	css({
		margin: '0 0 20px 0',
	})
);

export const holdAFundraiserFormWrapperStyle = css({
	[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		marginTop: '60px',
	},
});

export const holdAFundraiserTextareaStyle = css({
	height: '184px',
});



// WEBPACK FOOTER //
// ./src/page-styles/get-involved/detail/index.js